import React, { useContext } from "react";
import GlobalContext from "../../context/global";

const Header = ({ text, id, display, className }) => {
  if (!display) return;

  return (
    <h2 id={id} className={`text-center step-title ${className}`.trim()}>
      {text}
    </h2>
  );
};

export default Header;
